var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"footerPage"}},[_c('img',{staticClass:"img1",attrs:{"src":require("../assets/image/steam/footer.png"),"alt":""}}),(_vm.$route.name!='waitingPage' && _vm.$route.name!='percentage')?_c('img',{staticClass:"img2",attrs:{"src":require("../assets/image/steam/footer1.png"),"alt":""}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }